import React from 'react';
import AdManagement from '../components/AdManagement';

export default function AdManagementPage() {
	return <AdManagement />;
}
